import { Component, Input, OnDestroy } from '@angular/core';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CategoriesModalComponent } from '@form-field-module/modal-windows/categories-modal/categories-modal.component';
import { finalize, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CategoryChangeWarningStatusService } from '../../../core/services/category-change-warning-status.service';
import { TicketListItemDTO } from '@sb-tools/typescript/models/dto/ticket-list-item.dto';
import { BulkOperationsService } from '../../../core/services/bulk-operations.service';
import { BulkOperationsNotificationService } from '../../../core/services/bulk-operations-notification.service';
import { Category } from '@sb-tools/typescript/models/category.model';
import { CategoryDTO } from '@sb-tools/typescript/models/dto/category.dto';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CategoryFullNamePipe } from '../../../shared/pipes/category-full-name.pipe';

@Component({
    selector: 'app-category-selector-bulk',
    templateUrl: './category-selector-bulk.component.html',
    styleUrls: ['./category-selector-bulk.component.scss'],
    imports: [TooltipModule, NgClass, TranslateModule, CategoryFullNamePipe],
})
export class CategorySelectorBulkComponent implements OnDestroy {
    @Input() tickets: TicketListItemDTO[];

    category: CategoryDTO;
    isUpdatingCategory: boolean;

    private unsubscriber = new Subject<void>();

    constructor(
        public commonDataService: CommonDataService,
        private bsModalService: BsModalService,
        private bulkOperationsService: BulkOperationsService,
        private categoryChangeWarningStatusService: CategoryChangeWarningStatusService,
        private bulkOperationsNotificationService: BulkOperationsNotificationService,
    ) {}

    checkCategoryChangeStatus(): void {
        this.categoryChangeWarningStatusService.checkCategoryChangeStatus(
            this.tickets.map((t) => t.id),
            this.openCategoriesModal.bind(this),
            true,
        );
    }

    chooseCategory(selectedBranch: Category): void {
        this.isUpdatingCategory = true;

        const categoryId = selectedBranch && selectedBranch.id ? selectedBranch.id : null;

        this.bulkOperationsService
            .updateCategory({ ids: this.tickets.map((t) => t.id), categoryId })
            .pipe(
                finalize(() => {
                    this.isUpdatingCategory = false;
                }),
                takeUntil(this.unsubscriber),
            )
            .subscribe((result) => {
                if (result.areAllChangesSuccessful) {
                    if (categoryId) {
                        this.category = {
                            children: [],
                            label: selectedBranch.label,
                            name: selectedBranch.name,
                            id: selectedBranch.id,
                            parentData: selectedBranch.parentData as CategoryDTO[],
                        };
                    } else {
                        this.category = null;
                    }
                }

                this.bulkOperationsNotificationService.showNotificationForTickets(result);
            });
    }

    openCategoriesModal(): void {
        const initialState = {
            isPrivate: false,
            onChangeCategory: (selectedBranch) => {
                this.chooseCategory(selectedBranch);
            },
            selectedCategoryIds: [],
            isIgnoreUnselected: true,
        };

        this.bsModalService.show(CategoriesModalComponent, {
            initialState,
        });
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
